export const FrontendAr = {
  "options": "خيارات",
  
  "Instructions de l'ONMDM": "تعليمات السلك الوطني لأطباء الأسنان الموريتانيين",

  "Nos Services": "خدماتنا",

  "À l'ONMDM, nous nous efforçons de fournir des services exceptionnels dans le domaine dentaire, en travaillant sans relâche pour améliorer la santé bucco-dentaire des Mauritaniens.": 
  "في السلك الوطني لأطباء الأسنان الموريتانيين، نسعى جاهدين لتقديم خدمات استثنائية في مجال طب الأسنان، ونعمل بلا كلل لتحسين صحة الفم والأسنان للموريتانيين.",

  "Notre équipe est composée de professionnels hautement qualifiés, engagés à faire progresser les soins dentaires et les services grâce à des pratiques innovantes et des technologies de pointe." : 
  "يتكون فريقنا من محترفين ذوي كفاءة عالية، ملتزمين بتطوير رعاية وخدمات طب الأسنان من خلال ممارسات مبتكرة وتقنيات متقدمة.",

  "En savoir plus" : "المزيد من المعلومات",

  "Nos Partenaires": "شركاؤنا",

  "Textes juridiques et réglementaires" : "النصوص القانونية والتنظيمية",
  
  "L'Ordre National des Médecins Dentaires de Mauritanie rappelle à tous les praticiens que l'exercice de la profession est soumis aux règles déontologiques et réglementaires en vigueur." : 
  "يذكّر السلك الوطني لأطباء الأسنان الموريتانيين جميع الممارسين بأن مزاولة المهنة تخضع للقواعد الأخلاقية والتنظيمية السارية.",

  "Les obligations des médecins dentaires incluent notamment :" : "تشمل التزامات أطباء الأسنان ما يلي:",

  "Le respect du secret professionnel et des droits des patients" : "الالتزام بالسرية المهنية واحترام حقوق المرضى",

  "L'application des normes d'hygiène et de sécurité sanitaire" : "تطبيق معايير النظافة والسلامة الصحية",

  "L'interdiction de toute publicité ou promotion contraire à l'éthique" : "حظر أي إعلان أو ترويج غير أخلاقي",

  "La mise à jour régulière des connaissances médicales et techniques" : "التحديث المنتظم للمعارف الطبية والتقنية",

  "ONMDM" : "السلك الوطني لأطباء الأسنان الموريتانيين",

  "L'Ordre National des Médecins Dentaires de Mauritanie (ONMDM) est une organisation professionnelle représentant les médecins dentaires en Mauritanie. Nous travaillons pour améliorer la qualité des soins dentaires et promouvoir la santé bucco-dentaire dans tout le pays." : 
  "السلك الوطني لأطباء الأسنان الموريتانيين (ONMDM) هو منظمة مهنية تمثل أطباء الأسنان في موريتانيا. نعمل على تحسين جودة رعاية الأسنان وتعزيز صحة الفم والأسنان في جميع أنحاء البلاد.",

  "Développé par Mohamed Salem Ould Lekbar" : "تم التطوير بواسطة محمد سالم ولد لكبار",

  "Téléphone:" : "الهاتف:",

  "Contactez-nous" : "اتصل بنا",

  "Adresse:" : "العنوان:",

  "Route de Nouadhibou, Nouakchott, Mauritanie" : "طريق نواذيبو، نواكشوط، موريتانيا",

  "Email:" : "البريد الإلكتروني:",

  "Liens Utiles" : "روابط مفيدة",

  "À propos de l'ONMDM" : "حول السلك الوطني لأطباء الأسنان الموريتانيين",

  "Adhésion" : "الانضمام",

  "Actualités" : "الأخبار",

  "Suivez-Nous" : "تابعونا",

  "ONMDM. Tous droits réservés." : "السلك الوطني لأطباء الأسنان الموريتانيين. جميع الحقوق محفوظة.",

  "Textes Juridiques et Réglementaires": "النصوص القانونية والتنظيمية",

  "Déposez Votre Plainte": "قدم شكواك",

  "Les Actualités de l'ONMDM": "أخبار السلك الوطني لأطباء الأسنان الموريتانيين",

  "Déposez votre plainte": "قدم شكواك", 

  "Nom du patient": "اسم المريض",

  "Matricule": "الرقم التعريفي",

  "Donnez votre matricule": "أدخل رقمك التعريفي",

  "Donnez votre numéro de téléphone" : "أدخل رقم هاتفك",

  "Nom du Cabinet" : "اسم العيادة",

  "Docteur":"الطبيب",

  "Nom du Docteur" : "اسم الطبيب",

  "Écrivez votre plainte contre ce docteur" : "اكتب شكواك ضد هذا الطبيب",
  
  "Plainte": "شكوى",

  "Devis" : "خطة العلاج",

  "Page d'accueil": "الصفحة الرئيسية",

  "Chercher....": "بحث....",

  "Développé par Mohamed Salem Ould kbar" : "تم التطوير بواسطة محمد سالم ولد كبار",

};

